import {ErrorProcessor, LOAD_ERROR_MSG, ProcessingError} from '../types'
import {getLoadErrorSrc, sendOnly, updateAdditional} from '../utils'

const mcHostRE = 'https://mc.yandex.(ru|com)'

const MC = {
  host: new RegExp(mcHostRE),
  session: new RegExp(`${mcHostRE}/user_storage_set`),
  tag: new RegExp(`${mcHostRE}/metrika/tag.js`),
}

const deprioritizeOptions: Partial<ProcessingError> = {level: Ya.Rum.ERROR_LEVEL.INFO, service: 'metrika'}

export const processMetrikaErrors: ErrorProcessor = (error, scope) => {
  const loadErrorSrc = getLoadErrorSrc(error) || ''
  const dontMuteError = sendOnly(0.1)

  if (error.message === LOAD_ERROR_MSG.IMG && MC.host.test(loadErrorSrc)) {
    scope.updateError(deprioritizeOptions)

    if (MC.session.test(loadErrorSrc)) {
      return sendOnly(0.01) && updateAdditional(error, 'src', loadErrorSrc.split('?')[0]!)
    }

    return error
  } else if (error.message === LOAD_ERROR_MSG.SCRIPT && MC.tag.test(loadErrorSrc)) {
    return dontMuteError && scope.updateError(deprioritizeOptions)
  } else if (MC.tag.test(error.message)) {
    return dontMuteError && scope.updateError(deprioritizeOptions)
  }

  return error
}
